<template>
  <Molded>
    <div class="filters-inline">
      <div class="filters-inline__search">
        <div class="search-input-wrap">
          <i class="fa-solid fa-magnifying-glass search-input-icon"></i>
          <input
              class="search-input"
              type="text"
              placeholder="Pesquisar... (Enter)"
              :maxlength="50"
              :value="search"
              @input="$emit('update:search', $event.target.value)"
              @keyup.enter="$emit('filter-change')"
          />
        </div>
      </div>
      <div class="filters-inline__period text-center">
        <ButtonFilter :options="periodFilterOptions" :initialOption="initialPeriod" :value="period"
                      @input="$emit('update:period', $event)"/>
      </div>
      <div class="filters-inline__checks">
        <label class="filter-check">
          <input type="checkbox" class="filter-check__input" :checked="showDelivery"
                 @change="$emit('update:showDelivery', $event.target.checked); $emit('filter-change')"/>
          <span class="filter-check__box filter-check__box--delivery"></span>
          <span class="filter-check__label">Saídas</span>
        </label>
        <label class="filter-check">
          <input type="checkbox" class="filter-check__input" :checked="showDevolution"
                 @change="$emit('update:showDevolution', $event.target.checked); $emit('filter-change')"/>
          <span class="filter-check__box filter-check__box--devolution"></span>
          <span class="filter-check__label">Retornos</span>
        </label>
      </div>
    </div>
  </Molded>
</template>

<script>
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import ButtonFilter from "@nixweb/nixloc-ui/src/component/forms/ButtonFilter";

export default {
  name: "OsPanelCardItemFilter",
  components: {Molded, ButtonFilter},
  props: {
    search: {type: String, default: ""},
    period: {type: String, default: "today"},
    initialPeriod: {type: String, default: "today"},
    showDelivery: {type: Boolean, default: true},
    showDevolution: {type: Boolean, default: true},
    periodFilterOptions: {type: Array, default: () => []},
  },
};
</script>

<style scoped>
.filters-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filters-inline__search {
  flex: 0 1 340px;
  min-width: 220px;
}

.filters-inline__period {
  flex: 1 1 auto;
}

.filters-inline__period ::v-deep .btn-container {
  margin-left: 0;
  margin-bottom: 0;
}

.filters-inline__checks {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  margin-left: auto;
}

.filter-check {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

.filter-check__input {
  display: none;
}

.filter-check__box {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 2px solid #d1d5db;
  background: #fff;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-check__box::after {
  content: '';
  display: block;
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) scale(0);
  transition: transform 0.12s;
}

.filter-check__input:checked + .filter-check__box--delivery {
  background: #009183;
  border-color: #009183;
}

.filter-check__input:checked + .filter-check__box--devolution {
  background: #3d4eae;
  border-color: #3d4eae;
}

.filter-check__input:checked + .filter-check__box::after {
  transform: rotate(45deg) scale(1);
}

.filter-check__label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.search-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-icon {
  position: absolute;
  left: 14px;
  color: #9ca3af;
  font-size: 13px;
  pointer-events: none;
}

.search-input {
  width: 100%;
  height: 38px;
  padding: 0 16px 0 38px;
  font-size: 13.5px;
  color: #374151;
  border: 1.5px solid #e5e7eb;
  border-radius: 999px;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.search-input::placeholder {
  color: #b0b7c3;
  font-weight: 400;
}

.search-input:focus {
  background: #fff;
  box-shadow: 0 0 0 3px rgba(75, 180, 226, 0.12);
}
</style>
